import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { FeatureCategoryModule } from '@unpispas/feature/category';
import { FeatureShortcutModule } from '@unpispas/feature/shortcut';
import { FeaturePeriodModule } from '@unpispas/feature/period';

import { UppProductThumbComponent } from '../components/thumb/upp-thumb';
import { UppProductTicketComponent } from '../components/ticket/upp-ticket';
import { UppTicketKeyboardComponent } from '../components/ticket/keyboard/upp-keyboard';
import { UppProductCartComponent } from '../components/cart/upp-cart';
import { UppProductSelectComponent } from '../components/select/upp-select';
import { UppFamilyItemComponent } from '../components/family/upp-item';
import { UppProductEditComponent } from '../components/edit/upp-edit';
import { UppProductEditGroupComponent } from '../components/edit/upp-edit';
import { UppProductEditProductComponent } from '../components/edit/upp-edit';
import { UppProductEditGenericComponent } from '../components/edit/upp-edit';
import { UppProductEditFamilyComponent } from '../components/edit/upp-edit';
import { UppProductEditContextComponent } from '../components/edit/edit-context/upp-context';
import { UppProductStartComponent } from '../components/start/upp-start';
import { UppProductMatchComponent } from '../components/match/upp-match';

@NgModule({
    declarations: [
        UppProductThumbComponent,
        UppProductTicketComponent,
        UppTicketKeyboardComponent,
        UppProductCartComponent,
        UppProductSelectComponent,
        UppFamilyItemComponent,
        UppProductEditComponent,
        UppProductEditGroupComponent,
        UppProductEditProductComponent,
        UppProductEditGenericComponent,
        UppProductEditFamilyComponent,
        UppProductEditContextComponent,
        UppProductStartComponent,
        UppProductMatchComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DragDropModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
        FeatureCategoryModule,
        FeatureShortcutModule,
        FeaturePeriodModule
    ],
    exports: [
        UppProductThumbComponent,
        UppProductTicketComponent,
        UppProductCartComponent,
        UppProductEditComponent,
        UppProductSelectComponent,
        UppProductMatchComponent,
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureProductModule {}
